const BlockTypePreviewMini = ({ type }) => {
    const previews = {
        encabezado: (
            <div className="admin-preview-block admin-preview-header">
                <div className="admin-preview-bar admin-preview-bar-title" />
                <div className="admin-preview-bar admin-preview-bar-subtitle" />
                <div className="admin-preview-bar admin-preview-bar-text" />
            </div>
        ),
        portada: (
            <div className="admin-preview-block admin-preview-cover">
                <div className="admin-preview-bg" />
                <div className="admin-preview-bar admin-preview-bar-title admin-preview-light" />
                <div className="admin-preview-bar admin-preview-bar-subtitle admin-preview-light" />
            </div>
        ),
        texto: (
            <div className="admin-preview-block admin-preview-text">
                <div className="admin-preview-bar admin-preview-bar-title" />
                <div className="admin-preview-paragraphs">
                    <div className="admin-preview-line" />
                    <div className="admin-preview-line admin-preview-line-short" />
                    <div className="admin-preview-line" />
                </div>
            </div>
        ),
        filasDivididas: (
            <div className="admin-preview-block admin-preview-split">
                <div className="admin-preview-split-item">
                    <div className="admin-preview-split-text">
                        <div className="admin-preview-bar admin-preview-bar-title" />
                        <div className="admin-preview-line" />
                    </div>
                    <div className="admin-preview-split-image" />
                </div>
            </div>
        ),
        tarjetasImagen: (
            <div className="admin-preview-block admin-preview-image-cards">
                <div className="admin-preview-image-card" />
                <div className="admin-preview-image-card" />
            </div>
        ),
        lineaTiempo: (
            <div className="admin-preview-block admin-preview-timeline">
                <div className="admin-preview-timeline-item">
                    <div className="admin-preview-timeline-dot" />
                    <div className="admin-preview-timeline-content">
                        <div className="admin-preview-bar admin-preview-bar-title" />
                        <div className="admin-preview-line" />
                    </div>
                </div>
            </div>
        ),
        acordeon: (
            <div className="admin-preview-block admin-preview-accordion">
                <div className="admin-preview-accordion-item">
                    <div className="admin-preview-bar admin-preview-bar-title" />
                    <i className="pi pi-chevron-down" />
                </div>
                <div className="admin-preview-accordion-item admin-preview-accordion-active">
                    <div className="admin-preview-bar admin-preview-bar-title" />
                    <i className="pi pi-chevron-up" />
                </div>
            </div>
        ),
        tarjetasAccion: (
            <div className="admin-preview-block admin-preview-action-cards">
                <div className="admin-preview-action-card">
                    <div className="admin-preview-bar admin-preview-bar-title" />
                    <div className="admin-preview-btn" />
                </div>
            </div>
        ),
        carrusel: (
            <div className="admin-preview-block admin-preview-carousel">
                <div className="admin-preview-carousel-track">
                    <div className="admin-preview-carousel-slide" />
                    <div className="admin-preview-carousel-slide" />
                </div>
            </div>
        ),
        bloqueComercial: (
            <div className="admin-preview-block admin-preview-image-cards">
                <div className="admin-preview-image-card" />
                <div className="admin-preview-image-card" />
            </div>
        ),
    };

    return previews[type] || previews.encabezado;
};

export default BlockTypePreviewMini;
